export const isChatNotification = notification => (
  notification?.notification_type === 'chat' && Boolean(notification?.chat_id)
);

export const mergeNotifications = (...notificationLists) => {
  const seen = new Set();

  return notificationLists.flat().filter(notification => {
    const id = String(notification?._id || notification?.id || '');
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  }).sort((first, second) => (
    new Date(second?.createdAt || 0) - new Date(first?.createdAt || 0)
  ));
};
